import { render } from "./QuantityOfTransfersPerMonthChartContainer.vue?vue&type=template&id=6cb9590a"
import script from "./QuantityOfTransfersPerMonthChartContainer.vue?vue&type=script&lang=js"
export * from "./QuantityOfTransfersPerMonthChartContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__